export default {"src":"/_next/static/media/tnt.8e18aefb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};